var classes = {"location-qualifier":"SuggestionResult-module_location-qualifier__yHSgX"};

export { classes as default };
//# sourceMappingURL=SuggestionResult.module.scss.js.map
